import { Role } from '~/types/users'
import { userHasNoRoles, userHasRole } from './helpers'
import { middlewareInstructions, MiddlewareAction } from './types'

export default function isCustomer(): middlewareInstructions {
  if (userHasNoRoles()) {
    return {
      to: { name: 'subscription-portal-sign-in' },
      actions: MiddlewareAction.LOGOUT,
    }
  }
  if (userHasRole(Role.CUSTOMER)) return { to: { name: '' } }
  return userHasRole(Role.PARTNER)
    ? { to: { name: 'subscription-portal-subscriptions' } }
    : { to: { name: 'subscription-portal-partners' } }
}
